import { Subscription } from 'rxjs';
import { UiService } from '@services/ui.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';

import { environment } from '../../../environments/environment'
import { AuthService } from '@services/auth.service';
import { AuthUser } from '@classes/auth/auth-user';
import { NavLink } from '@classes/nav-link';
import { NavService } from '@services/nav.service';
import { RoleName } from '@enums/role-name.enum';
import { MatDialog } from '@angular/material/dialog';
import { SitesService } from '@services/sites.service';
import { DialogChooseDropdownComponent } from '@components/dialog-choose-dropdown/dialog-choose-dropdown.component';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isAuth: boolean;
  @Output() sidenavToggle = new EventEmitter<void>();
  appName: string = environment.appName;
  appVersion: string = environment.version;
  user: AuthUser;
  headerNavLinks: NavLink[];

  isRouteLoading: boolean;
  isDispatcher: boolean;

  private subscription = new Subscription();
  private headerNavLinksSubscription: Subscription;

  constructor(
    private authSrv: AuthService,
    private navSrv: NavService,
    private uiSrv: UiService,
    private dialog: MatDialog,
    private sitesSrv: SitesService
  ) { }

  ngOnInit() {
    this.initSubscriptions();
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
          this.isRouteLoading = loadingState;
        })
    );
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authSrv.getUser();
      this.isDispatcher =
        this.user.role.name === RoleName.bizzdev ||
        this.user.role.name === RoleName.super_admin ||
        this.user.role.name === RoleName.admin ||
        this.user.role.name === RoleName.admin_subcontractor ||
        this.user.role.name === RoleName.dispatcher;
      this.setHeaderNavLinks();
    } else {
      this.user = null;
      this.headerNavLinks = null;
      this.clearHeaderNavLinksSubscription();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearHeaderNavLinksSubscription();
  }

  private setHeaderNavLinks(): void {
    this.clearHeaderNavLinksSubscription();
    this.headerNavLinksSubscription = this.navSrv.getHeaderNavLinks$().subscribe(links => {
      this.headerNavLinks = links;
    });
  }

  private clearHeaderNavLinksSubscription(): void {
    if (this.headerNavLinksSubscription) {
      this.headerNavLinksSubscription.unsubscribe();
      this.headerNavLinksSubscription = null;
    }
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }

  goTocloud() {
    this.uiSrv.loadingStateChanged.next(true);

    this.sitesSrv.getList().subscribe((sites) => {
      this.uiSrv.loadingStateChanged.next(false);
      const dialog = this.dialog.open(DialogChooseDropdownComponent, {
        maxWidth: "500px",
        data: {
          title: "sitesCloud.dialog.title",
          message: "sitesCloud.dialog.message",
          label: "sitesCloud.dialog.label",
          list: sites
        }
      })
      dialog.afterClosed().subscribe(response => {
        if (response) {
          if (response.documentUrl) {
            window.open(response.documentUrl, "_blank");
          } else {
            this.uiSrv.showSnackbar("Ce donneur d'ordre ne dispose pas d'URL cloud dans ses paramètres.");
          }
        }
      })
    })
  }

  redirectToRuptela(): void {
    window.open(`https://basic.m-worker.com/`, '_blank');

  }
}
